/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TicketTimeLimitOverrideValidationError,
    TicketTimeLimitOverrideValidationErrorFromJSON,
    TicketTimeLimitOverrideValidationErrorFromJSONTyped,
    TicketTimeLimitOverrideValidationErrorToJSON,
} from './';

/**
 * 
 * @export
 * @interface TicketTimeLimitOverrideValidationErrors
 */
export interface TicketTimeLimitOverrideValidationErrors {
    /**
     * 
     * @type {Array<TicketTimeLimitOverrideValidationError>}
     * @memberof TicketTimeLimitOverrideValidationErrors
     */
    errors?: Array<TicketTimeLimitOverrideValidationError> | null;
}

export function TicketTimeLimitOverrideValidationErrorsFromJSON(json: any): TicketTimeLimitOverrideValidationErrors {
    return TicketTimeLimitOverrideValidationErrorsFromJSONTyped(json, false);
}

export function TicketTimeLimitOverrideValidationErrorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketTimeLimitOverrideValidationErrors {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(TicketTimeLimitOverrideValidationErrorFromJSON)),
    };
}

export function TicketTimeLimitOverrideValidationErrorsToJSON(value?: TicketTimeLimitOverrideValidationErrors | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'errors': value.errors === undefined ? undefined : (value.errors === null ? null : (value.errors as Array<any>).map(TicketTimeLimitOverrideValidationErrorToJSON)),
    };
}


